import React, { useEffect, useState } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";
//components
import OptionArea from "./optionArea";
import OptionSectors from "./optionSectors";
import Bsa from "./optionBsa";
import KeyOffering from "./optionKeyOffering";

function Stage2(props) {
  const [step, setStep] = useState("");

  useEffect(() => {
    document.getElementById("title-stage2").focus();
    props.loadingUserOff();
  }, []);
  return (
    <section className="section-stage2">
      <MetaTags>
        <title>Digital Lovers Festival - Página Palco 2</title>
      </MetaTags>
      <a id="title-stage2" className="title-home" tabIndex={12}>
        Página Palco 2
      </a>
      <div className="div-buttos-stage2">
        <button
          className={`${step === "_a" ? "option-stage2-selected" : "option-stage2"
            }`}
          id="option-stage2"
          tabIndex={13}
          onClick={() => setStep("_a")}
          title="Acesse a página Áreas de negócios"
        >
          Áreas de negócios
        </button>
        <button
          className={`${step === "_b" ? "option-stage2-selected" : "option-stage2"
            }`}
          id="sectors-stage2"
          tabIndex={14}
          onClick={() => setStep("_b")}
          title="Acesse a página Setores"
        >
          Setores
        </button>
        <button
          className={`${step === "_c" ? "option-stage2-selected" : "option-stage2"
            }`}
          tabIndex={15}
          onClick={() => setStep("_c")}
          title="Acesse a página BSA"
        >
          BSA
        </button>
        <button
          className={`${step === "_d" ? "option-stage2-selected" : "option-stage2"
            }`}
          tabIndex={16}
          onClick={() => setStep("_d")}
          title="Acesse a página Key Offering"
        >
          Key Offering
        </button>
      </div>
      <div>
        {step === "_a" && <OptionArea state={props.state} />}
        {step === "_b" && <OptionSectors state={props.state} />}
        {step === "_c" && <Bsa state={props.state} />}
        {step === "_d" && <KeyOffering state={props.state} />}
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Stage2);
